import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import type { InventoryRecord, InventorySummary } from '@aigftpwatch/shared';

export function useInventory(accountId?: number, productId?: number) {
  const params = new URLSearchParams();
  if (accountId) params.set('account_id', String(accountId));
  if (productId) params.set('product_id', String(productId));
  const qs = params.toString() ? `?${params}` : '';
  return useQuery({
    queryKey: ['inventory', accountId, productId],
    queryFn: () => api.get<InventoryRecord[]>(`/inventory${qs}`).then((r) => r.data),
  });
}

export function useInventorySummary() {
  return useQuery({
    queryKey: ['inventory', 'summary'],
    queryFn: () => api.get<InventorySummary[]>('/inventory/summary').then((r) => r.data),
  });
}

export function useAdjustInventory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { account_id: number; product_id: number; quantity_change: number; reason: string }) =>
      api.post('/inventory/adjust', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['inventory'] }),
  });
}
